module.exports = __webpack_public_path__ + "img/NA.24279a9a.svg";